import state from "./state";

const getters = Object.keys(state).reduce((getters, key) => {
    getters[key] = (state) => state[key];
    return getters;
}, {});

const customGetter = {
    ...getters,
    getJenisTransaksi: (state) => (jenis) => {
        switch (jenis) {
            case "beli_deposit":
                return "Top Up Deposit";
            case "beli_emoney":
                return "Top Up E-Payment";
            case "snap_transaksi_nota":
                return "Transaksi Snapclean";
            case "selesai":
                return "Transaksi Selesai";
            case "transaksi":
                return "Transaksi reguler";
            case "bukti_ambil":
                return "Bukti Pengambilan";
			case "pelunasan":
                return "Bukti Pelunasan";
            case "pengambilan":
            default:
                return "Pengingat Pengambilan";
        }
    },
    getStatusPesan: (state) => (status) => {
        switch (status) {
            case 1:
                return "Antrian";
            case 2:
                return "Diproses";
            case 3:
                return "Terkirim";
            case 4:
                return "Gagal";
            default:
                return "";
        }
    },
    jwtToken: (state) => () => {
        let token = localStorage.getItem("token");
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    },
};
export default customGetter;
